import React, { Fragment } from 'react';
var CollapsibleContent = function (props) {
    return React.createElement(Fragment, null, props.children);
};
export default CollapsibleContent;
